import { ExemplosVerticalFieldModel } from '@mchat-rf/consulta-seguimento/components/ExemplosVerticalField'
import { PassouFalhouEnum } from '@mchat-rf/consulta-seguimento/enums-consultaSeguimento'
import { ConsultaSeguimentoAplicacaoItemModel } from '@mchat-rf/consulta-seguimento/model-consultaSeguimento'
import { SimNaoEnum } from 'components/form'

export enum ConsultaSeguimentoPergunta11ExemplosEnum {
  SORRI_QUANDO_VOCE_SORRI = 'SORRI_QUANDO_VOCE_SORRI',
  SORRI_QUANDO_VOCE_ENTRA_NO_QUARTO = 'SORRI_QUANDO_VOCE_ENTRA_NO_QUARTO',
  SORRI_QUANDO_VOCE_VOLTA = 'SORRI_QUANDO_VOCE_VOLTA',
  ESTA_SEMPRE_SORRINDO = 'ESTA_SEMPRE_SORRINDO',
  SORRI_PARA_BRINQUEDO_OU_ATIVIDADE = 'SORRI_PARA_BRINQUEDO_OU_ATIVIDADE',
  SORRI_AO_ACASO_OU_SEM_MOTIVO = 'SORRI_AO_ACASO_OU_SEM_MOTIVO',
}

export interface ConsultaSeguimentoPergunta11Model extends ConsultaSeguimentoAplicacaoItemModel {
  PERGUNTA_11_HEADER?: SimNaoEnum
  PERGUNTA_11_EXEMPLOS?: ExemplosVerticalFieldModel<ConsultaSeguimentoPergunta11ExemplosEnum>
  PERGUNTA_11_FREQUENCIA?: PassouFalhouEnum
}
